import { Component, OnInit } from '@angular/core';
import {UserRoleCategoryModel} from '../../../../shared/dto/user-role-category.model';
import {Status} from '../../../../shared/enums/status.enum';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActionMode} from '../../../../shared/enums/action-mode.enum';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import swal from "sweetalert2";
import {UserroleCategoryService} from '../../../../shared/service/userrole-category.service';
import {Router} from '@angular/router';
import {TokenStorageService} from '../../../../shared/service/token-storage.service';

@Component({
  selector: 'app-user-role-category-popup',
  templateUrl: './user-role-category-popup.component.html',
  styleUrls: ['./user-role-category-popup.component.scss']
})
export class UserRoleCategoryPopupComponent implements OnInit {
  status = Status;
  public form: FormGroup;
  userRoleCategories: UserRoleCategoryModel[] = [];
  public selectedState: string;
  public selectedMode;
  public description: string;
  public userRoleCategoryCode: string;
  public href: string = "";

  ActionMode = ActionMode;
  constructor( public activeModal: NgbActiveModal,
               public userRoleCategoryService: UserroleCategoryService,
               private tokenStorageService: TokenStorageService,
               private router : Router) { }

  ngOnInit() {
    this.form = new FormGroup({
      userRoleCategoryCode: new FormControl(null,Validators.required),
      status: new FormControl(null,Validators.required),
      description: new FormControl(null,Validators.required),
    });
    this.href = this.router.url;
    this.loadAllUserRoleCategories();
    if (this.selectedMode === ActionMode.VIEW) {
      this.form.disable();
    }
  }

  loadAllUserRoleCategories(){
    this.userRoleCategoryService.getAllUserRoleCategory().subscribe(
      (data: UserRoleCategoryModel[]) => {
        this.userRoleCategories = data;
      }
    );
  }

  onSubmit(){
    let isValid: boolean = true;
    let errorMessage: string = '';

    if (!this.form.valid) {
      isValid = false;
      errorMessage = 'Please, Fill the form Data...!'
    }
    if (isValid) {
      swal.fire({
        title: "Are you sure, you want to submit?",
        text: "",
        showCancelButton: true,

        confirmButtonText: "Yes"
      }).then((result)=> {
        if(result.value) {
          const userRoleModel: UserRoleCategoryModel = new UserRoleCategoryModel(
            this.userRoleCategoryCode,
            this.description,
            this.selectedState,
            this.tokenStorageService.getUserObjectToken().username,
            null,
            this.href
          );
          this.userRoleCategoryService.saveUserRoleCategory(userRoleModel).subscribe(
            (success: string) => {
              swal.fire("Success", "Details submitted successfully", "success");
              this.loadAllUserRoleCategories();
            },
            (error) => {
              console.log(error);
              swal.fire("Sorry!", "Something went wrong...!", "error");
            },
            () => {
              this.activeModal.close("Saved");
            }
          );
          }
        }, reason => {
        }
      );
    } else{
      swal.fire('Error',errorMessage,'error');
    }
  }

}
